import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

export const onlineGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  if (!navigator.onLine) {
    // Rediriger vers le dashboard si hors ligne
    router.navigate(['/dashboard']);
    return false;
  }

  return true;
};
